import { ALL_FEATURE_TYPES_MAP } from "./user-features-constants";

export const DRAWER_WIDTH_DESKTOP = 96;
export const DRAWER_WIDTH_MOBILE = 240;
export const CTA_TYPE = {
  active_cta: "active-cta",
  primary_cta: "primary-cta",
  secondary_cta: "secondary-cta",
  secondary_active_cta: "secondary-active-cta",
  secondary_cta_with_accent: "secondary-cta-with-accent",
} as const;
type CtaTypeKeys = keyof typeof CTA_TYPE;
export type CtaTypes = (typeof CTA_TYPE)[CtaTypeKeys]

export const CTA_SIZE = {
  small: "small",
  medium: "medium",
  large: "big",
} as const;
type CtaSizeKeys = keyof typeof CTA_SIZE;
export type CtaSizeTypes = (typeof CTA_SIZE)[CtaSizeKeys]

export const DATE_TIME_FORMATS = {
  dayMonthYearShort: "DD MMM YY",
  dayMonthYear: "DD/MM/YYYY",
  yearMonthDay1: "YYYY/MM/DD",
  day_month_year: "DD-MM-YYYY",
  yearMonthDay: "YYYY-MM-DD",
  monthYear: "MM/YYYY",
  yearMonthDayTime: "YYYY-MM-DD hh:mm A",
  time: "hh:mm A",
  dayMonthYearHHMM: "DD/MM/YYYY , hh:mm A",
  dayMonth: 'DD-MM',
  dayMonthTime:"D MMM hh:mm A",
  hourMinute: 'hh:mm A',
  monthDayYear: 'MMM DD, YYYY',
  X: "x",
  hmmA: "hh:mm A",
  hhmmA: "hh:mm A",
  DDMMYYY1: "DD-MM-YYYY",
  doMMM: "Do MMM",
  dmy: "l",
};

export const ALL_MONTHS = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

export const SENT_DIGITAL_BILL = {
  EMAIL: "Email",
  SMS: "SMS",
  WHATSAPP: "WhatsApp",
};

export const GROUP_METHODS = {
  Payment:"Payment",
  User:"User"
}

export const ACCOUNT_SUMMARY: any={
  sales: {
    id: "sales",
    label: "Sales Summary",
    feature: ALL_FEATURE_TYPES_MAP.SALES_BY_DAY,
  },
  payment: {
    id: "payment",
    label: "Payment Summary",
    feature: ALL_FEATURE_TYPES_MAP.PAYMENTS_BY_DAYS
  },
  credit: {
    id: "credit",
    label: "Credit Summary",
    feature: ALL_FEATURE_TYPES_MAP.BALANCE_BY_DAYS
  },
  royalty : {
    id: "royalty",
    label: "Franchise Invoice Reports",
    feature: ALL_FEATURE_TYPES_MAP.FRANCHISE_INVOICE_REPORTS
  }
}

//map status of branches/stores
export const BRANCH_STATUS_MAP = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};

export const NUMBER_OF_MONTHS_IN_YEAR = 12;

export const MONTHS_NUMERIC_MAP: any = {
  JAN: "01",
  FEB: "02",
  MAR: "03",
  APR: "04",
  MAY: "05",
  JUN: "06",
  JUL: "07",
  AUG: "08",
  SEP: "09",
  OCT: "10",
  NOV: "11",
  DEC: "12",
};

export const BUSINESS_DAYS_NAME_MAP: any = {
  mon: {
    key: "mon",
    shortName: "Mon",
    longName: "Monday",
  },
  tue: {
    key: "tue",
    shortName: "Tue",
    longName: "Tuesday",
  },
  wed: {
    key: "wed",
    shortName: "Wed",
    longName: "Wednesday",
  },
  thu: {
    key: "thu",
    shortName: "Thu",
    longName: "Thursday",
  },
  fri: {
    key: "fri",
    shortName: "Fri",
    longName: "Friday",
  },
  sat: {
    key: "sat",
    shortName: "Sat",
    longName: "Saturday",
  },
  sun: {
    key: "sun",
    shortName: "Sun",
    longName: "Sunday",
  },
};

export const MESSAGE_TYPE = {
  success: "success",
  error: "error",
  warning: "warning",
};

export const CATALOG_DATA_REDUCER_KEYS = {
  brands: "brands",
  categories: "categories",
  memberships: "memberships",
  categoryGroups: "categoryGroups",
  channelDefs: "channelDefs",
  channelvos: "channelvos",
  charges: "charges",
  itemSchedules: "itemSchedules",
  menus: "menus",
  taxAreas: "taxAreas",
  taxTypes: "taxTypes",
};

export const CURRENT_CURRENCY_SYMBOL = "₹";
export const MENU_ITEM_COMPONENT_ID = {
  item_basic_details: "item-basic-details",
  item_additional_details: "item-additional-details",
  item_price_info: "item-price-info",
  item_image_details: "item-image-details",
};

export const MANDATORY_FIELD_MAP: any = {
  "info.categoryId": { type: "string" },
  "info.measuringUnit": { type: "string" },
  "info.longName": { type: "string" },
  "info.itemNature": { type: "string" },
  "info.categoryGroupId": { type: "string" }
  // "priceInfo.taxTypeIds": { type: "array" }
};

export const MANDATORY_FIELD_VALUES_MAP: any = {
  "info.categoryId": "CategoryId is required",
  "info.measuringUnit": "Measuring Unit is required",
  "info.longName": "Item Name is required",
  "info.itemNature": "Item Nature is required",
  "info.categoryGroupId": 'Department is required',
  // "priceInfo.taxTypeIds": "Tax is required",
  prices: "Please add channel specific prices",
  noVariantsPresent: "Please add a variant item",
};

export const MENU_ITEM_VARIANTS_COMPONENT_ID = {
  group_item_variant_basic_details: "group-item-variant-basic-details",
  variant_item_additional_details: "variant-item-additional-details",
  variant_item_price_info: "variant-item-price-info",
  group_item_variant_image_details: "group-item-variant-image-details",
  variant_attributes_details: "variant-attributes-details",
  variant_basic_info: "variant-basic-info",
};

export const MANDATORY_TABS: any = [
  MENU_ITEM_COMPONENT_ID.item_basic_details,
  MENU_ITEM_COMPONENT_ID.item_price_info,
  MENU_ITEM_COMPONENT_ID.item_additional_details,
  MENU_ITEM_VARIANTS_COMPONENT_ID.group_item_variant_basic_details,
  MENU_ITEM_VARIANTS_COMPONENT_ID.variant_attributes_details,
  MENU_ITEM_VARIANTS_COMPONENT_ID.variant_item_price_info,
];
export const COMPONENT_MODES = {
  addNewMode: "addNewMode",
  editMode: "editMode",
  viewMode: "viewMode",
} as const;
type ModeKeys = keyof typeof COMPONENT_MODES;
export type ComponentModeType = (typeof COMPONENT_MODES)[ModeKeys]


export const dashboardPaymentModes = {
  Paytmedc: "Paytm EDC",
  Paytmqr: "Paytm QR",
  Paytmqdqr: "Paytm DQR",
  razorpay: "Razorpay",
  "Pine Labs": "Pine Labs",
  pinelabs: "Pine labs",
  "pine-lab": "Pine Labs",
};

export const UPLOAD_INSTRUCTIONS = [
  "Upload can be performed by a Manager or an Admin, as applicable, with an email address verified in the account",
  "Tap on the Send me Template button at the bottom to receive an email with a template as an attachment and a detailed instructions to prepare your data for uploading to your account.",
  "Prepare the data for upload in the standard comma-separated values (CSV) format, saved from Excel or similar spreadsheet software",
  "Enter data of each record in a separate row and the fields under the respective columns shown on the template.",
  "The maximum length of characters allowed in each field is indicated within parenthesis on the instructions.",
  "The fields that are mandatory are indicated against the respective field on the instructions.",
  "Upon upload of a file, any data errors found by the system will be indicated against each record on the last column and sent to you via email for corrections.",
  "Upon successful upload, you will receive an email from the system indicating the number of records uploaded to your account along with further instructions, if any, to process the uploaded data",
];

export const BULK_TYPE = {
  bulk_image: "bulk_image",
  bulk_price: "bulk_price",
  bulk_item: "bulk_item",
  bulk_item_setting: "bulk_item_setting",
  bulk_add_ons: "bulk_add_ons",
  bulk_add_ons_update: "bulk_add_ons_update",
  bulk_item_delete: "bulk_item_delete",
};

export const USER_ROLES = {
  admin: "Admin",
  manager: "Manager",
  user: "User",
} as const;
type RoleKeys = keyof typeof USER_ROLES;
export type Role = typeof USER_ROLES[RoleKeys]

// Menu items type
export const ITEM_TYPE = {
  variant: "Variant",
  item: "Item",
  group: "Group",
};

// Documement titles for different pages
export const DOCUMENT_TITLE_TYPE = {
  login: "Login - Rista Merchant",
  dashboard: "Rista Dashboard",
  reports: "Rista Reports",
  catalog: "Rista Catalog",
  outlets: "Rista Outlets",
  accounting: "Rista Accounting",
  default: "Rista Merchant",
  downloads: "Rista Downloads",
  tables: "Rista Tables",
};

export const TABLES_TABS_MAP = {
  manage_tables: {
    tabId: "manage_tables",
    text: "Manage Tables",
    feature: ALL_FEATURE_TYPES_MAP.MANAGE_RESOURCE,
  },
  manage_table_areas: {
    tabId: "manage_table_areas",
    text: "Table Areas",
    feature: ALL_FEATURE_TYPES_MAP.MANAGE_RESOURCE,
  }
} as const;

export const outletStatus = "outletStatus";

export const COMPARE_DATES = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  WEEK: 'Last Week',
  MONTH: 'Last Month',
  '3_MONTHS': 'Last 3 Months'
}

export const SALES_SUMMARY_DETAILS={
  GROSS_SALES: "Gross sales",
  SALES_RETURN: "Sales return",
  DISCOUNTS: "Discounts",
  DIRECT_CHARGES:"Direct charges",
  NET_SALES: "Net Sales",
  OTHER_CHARGES: "Other charges",
  TAXES:"Taxes",
  ROUNDING:"Rounding",
  TIP:"Tip",
  TOTAL_REVENUE:"Total Revenue",
  PAYMENTS: "Payments",
  BALANCE_DUE:"Balance Due",
  DISCOUNT_SUMMARY: "Discount Summary",
  ACCOUNT_SUMMARY: "Account Summary",
  NET_SALE_SUMMARY: "Net Sale Summary",
  CHARGE_SUMMARY: "Charge Summary",
  TAX_SUMMARY: "Tax Summary",
  PAYMENT_SUMMARY: "Payment Summary",
  CHANNEL_SUMMARY: "Channel Summary",
  BRAND_SUMMARY: "Brand Summary",
  DISCOUNT_TOTAL: "Discount Total",
  TAX_TOTAL: "Tax Total",
  NET_SALES_TOTAL: "Net Sales Total",
  CHARGE_TOTAL: "Charge Total",
  PAYMENT_TOTAL: "Payment Total",
  NO_OF_SALES: "No. of sales",
  AVG_SALES: "Avg sales",
  NO_OF_PEOPLE: "No. of People",
  AVG_SALE_PER_PERSON: "Avg sale per person",
  NO_OF_OPEN_ORDERS: "No. of open orders",
  OPEN_ORDER_TOTAL: "Open order total",
  OPEN_ORDER_PAID_AMOUNT: "Open order paid amount",
  SALE_METRIC: "Sale Metric",
} 

export const optionsForDates = [
  {
    value: 'Today',
    totalDays: 0
  },
  {
    value: 'Yesterday',
    totalDays: 1
  },
  {
    value: 'Last Week',
    totalDays: 6
  },
  {
    value: 'Last Month',
    totalDays: 30,
  },
  {
    value: 'Last 3 Months',
    totalDays: 90
  },
  {
    value: 'Custom Range',
    totalDays: 90
  }
]

export const VIEW_REPORT_OPTION = [
  {
    value: 'Today',
    totalDays: 0
  },
  {
    value: 'Yesterday',
    totalDays: 1
  },
  {
    value: 'Last Week',
    totalDays: 6
  },
  {
    value: 'Last Month',
    totalDays: 30,
  },
  {
    value: 'Last 3 Months',
    totalDays: 90
  },
  {
    value: 'Custom Range',
    totalDays: 30000
  }
]

interface DataItem {
  id: string;
  label: string;
  type: string;
  headerText?: any;
  placeholderText?:any;
}

//map audit types in sales audit log details
export const SALES_AUDIT_OPTIONS_MAP: Record<string, DataItem> = {
  allorders: { id: "allorders", label: "All Orders", type: "All Orders" },
  payment: {
    id: "payment",
    label: "Payment",
    type: "Paid Orders",
    headerText: "Paid",
    placeholderText:"Mode"
  },
  balancedue: {
    id: "balancedue",
    label: "Balance Due",
    type: "Orders with Balance Due",
    headerText: "Balance",
  },
  discount: {
    id: "discount",
    label: "Discount",
    type: "Discounted Orders",
    headerText: "Discount",
    placeholderText:"Discount"
  },
  nc: { id: "nc", label: "NC", type: "Non Chargeable Orders" },
  open: { id: "open", label: "Open", type: "Open Orders" },
  cancelled: { id: "cancelled", label: "Cancelled", type: "Cancelled Orders" },
  voided: { id: "voided", label: "Voided", type: "Voided Orders" },
  returns: { id: "returns", label: "Returns", type: "Returned Orders" },
  cancelledtickets: {
    id: "cancelledtickets",
    label: "Cancelled Tickets",
    type: "Orders with Cancelled Tickets",
    headerText: "Cancelled Tickets",
  },
  modifiedtickets: {
    id: "modifiedtickets",
    label: "Modified Tickets",
    type: "Orders with Modified Tickets",
    headerText: "Modified Tickets",
  },
  modifiedafterprint: {
    id: "modifiedafterprint",
    label: "Modified After Print",
    type: "Order Modified after Print",
  },
  reprints: {
    id: "reprints",
    label: "Reprints",
    type: "Bill Reprinted Orders",
    headerText: "Bill Reprints",
  },
};


export const EDITED_AUDITS: any = [
  SALES_AUDIT_OPTIONS_MAP.cancelledtickets.id,
  SALES_AUDIT_OPTIONS_MAP.modifiedtickets.id,
];

export const compareToData: Record<string, Record<string, string | number>> = {
  0: {
    title: 'Previous Period',
  },
  7: {
    title: 'Previous Week',
    startDate: 14,
    endDate: 8
  },
  30: {
    title: 'Previous Month',
    startDate: 60,
    endDate: 31,
  },
  365: {
    title: 'Previous Year',
    startDate: 60,
    endDate: 31,
  }
}
export const EMAIL_VALIDATION_ERROR = 'Email Id not added! Please add and verify the email Id from the access module to receive the report on your email';
export const EMAIL_NOT_VERIFIED = 'Report can not be sent on your email! Please verify the email Id from the access module to receive the report on your email';
export const TABLE_RANGE_ERROR = 'Please enter a valid range'

export const GROUP_BY_TYPES = {
  branch: "branch",
  brand: "brand" 
}

export const SORT_VALUE_TYPES={
  number:"number",
  string:"string"
}

export const PAYMENT_SUMMARY_API_SUFFIX={
  payment:"bills",
  users:"users"
}

export const IMAGE_TYPES = {
  ITEM: "Item",
  ITEM_PRICE: "ItemPrice",
  ITEM_DETAIL: "Item Detail",
  CATEGORY: "Category",
  SUB_CATEGORY: "SubCategory",
  USER: "User",
  RESOURCE: "Resource",
  BUSINESS: "Business",
  SIGNATURE: "Signature",
  OTHERS: "Others",
  PANCARD: "Pancard",
};

export const TESTING_DROPDOWN_VALUE = {
  1 : {
   value : 1,
   name: 'testing 1'
  },
  2 : {
   value : 2,
   name: 'testing 2'
  },
  3 : {
   value : 3,
   name: 'testing 3'
  },
  4 : {
   value : 4,
   name: 'testing 4'
  }
}

export const TESTING_EMAIL = ['nitin.mishra@dotpe.in', 'abhishek.sharma@dotpe.in', 'deepak.yadav@dotpe.in']
export const SYSTEM = "SYSTEM";
